<div [@fadeInXY]="true" class="subject-facet-wrapper" *ngIf="!!options.length">
    <div class="facet-title selenium-facet-title" (click)="onToggle()">
        <span class="toggle visible">
            <i
                [@rotateRight]="isCollapsed"
                class="fas"
                [ngClass]="{ 'fa-plus': isCollapsed, 'fa-minus': !isCollapsed }"
            ></i>
        </span>
        {{ title }}
        <span *ngIf="selectedFiltersCount">({{ selectedFiltersCount }})</span>
    </div>
    <div
        [@fadeInXY]="isCollapsed"
        *ngIf="!isCollapsed"
        class="facet-content"
        [ngClass]="{ hidden: isCollapsed, grid: layout === 'grid' }"
    >
        <div class="options-wrapper selenium-facet-options">
            <div class="option py-1" *ngFor="let option of options">
                <input
                    type="checkbox"
                    [id]="option.id || option.label"
                    [attr.data-gtmlabel]="title + ' - ' + option.label"
                    [ngModel]="option.checked"
                    (change)="onCheckboxChange($event, option)"
                />
                <ng-container>
                    <label [for]="option.id || option.label">{{ option.label }}</label>
                </ng-container>
            </div>
            <div class="option" *ngFor="let option of fakeOptions"></div>
        </div>
    </div>
</div>
